import React from "react";
import PropTypes from "prop-types";
import Image from "./ImageElement";
import { Link } from "react-router-dom";
import ChevronUp from "../svg/ICON_chevronUP_Dark.svg";
import ChevronDown from "../svg/ICON_chevronDown_Dark.svg";
import "../css/Service.css";

/**
 * Service component
 */
class Service extends React.Component {
  static displayName = "Service";
  static propTypes = {
    className: PropTypes.string,
    screen: PropTypes.string.isRequired,
    service: PropTypes.object.isRequired,
  };
  static defaultProps = {};

  /**
   * @constructor
   * @param {Object} props
   */
  constructor(props) {
    super(props);
    this.className = "Service";

    this.state = {
      open: false,
    };
  }

  /**
   * @override
   */
  render() {
    const service = this.props.service;
    return (
      <div
        className={`${this.className} ${this.state.open ? "open" : "close"}`}
      >
        <div className={`${this.className}__images`}>
          {service.images().map((image, index) => (
            <Image
              key={image.ID}
              src={image[`${this.props.screen}_src`]}
              className={index === 0 ? "main" : "secondary"}
              alt={image.alt}
            />
          ))}
        </div>
        <div className={`${this.className}__text`}>
          <h2 className={`${this.className}__title`}>{service.Title}</h2>
          <div
            className={`${this.className}__excerpt`}
            dangerouslySetInnerHTML={{
              __html: service.Excerpt,
            }}
          />
          <div className={`${this.className}__expand`}>
            <div
              className={`${this.className}__content`}
              dangerouslySetInnerHTML={{
                __html: service.Content,
              }}
            />
            <div className={`${this.className}__action`}>
              <Link to="/new-offer">
                {service.ButtonTitle}
                <span className="icon is-right is-dark" />
              </Link>
            </div>
          </div>
          <div
            className={`${this.className}__closer`}
            onClick={() => this.setState({ open: !this.state.open })}
          >
            {this.state.open ? "Fermer" : "Ouvrir"}
            <img
              src={this.state.open ? ChevronUp : ChevronDown}
              alt="Up"
              className="icon"
            />
          </div>
        </div>
      </div>
    );
  }
}

export default Service;



// WEBPACK FOOTER //
// ./src/components/Service.js